import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { FlexSpace, FormModal } from '@ubeya/shared-web/components';
import { responsiveFields } from '@ubeya/shared-web/style';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import RatesFields from './RatesFields';
import RatesWithEffective from './RatesWithEffective';

const Container = styled(FlexSpace)`
  margin-top: -30px;
  ${responsiveFields.mobile}
`;

const RateModal = ({ selectedRate, isFlatWage, mappedPositions, onClose, onConfirm }) => {
  const { t } = useContext(ConfigContext);

  const title = useMemo(
    () =>
      `${selectedRate.id ? t('editRate') : t('addRate')}${
        selectedRate.positionId ? ` - ${mappedPositions[selectedRate.positionId]?.label}` : ''
      }`,
    [mappedPositions, selectedRate.id, selectedRate.positionId, t]
  );

  const showWithEffectiveRates = !!selectedRate.positionId;

  return (
    <FormModal
      initialValues={selectedRate}
      isPaddingContent={!showWithEffectiveRates}
      size={showWithEffectiveRates ? 'medium' : 'small'}
      onSubmit={(values) => {
        onConfirm(values);
        onClose();
      }}
      onClose={onClose}
      title={title}
      confirmText={t('save')}
      showCancelButton>
      {showWithEffectiveRates ? (
        <RatesWithEffective isFlatWage={isFlatWage} selectedRate={selectedRate} />
      ) : (
        <Container>
          <RatesFields isFlatWage={isFlatWage} />
        </Container>
      )}
    </FormModal>
  );
};

export default RateModal;
